/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { RichTextComponent } from '@msdyn365-commerce/core';
import { ITermsAndConditionsPageViewProps } from './terms-and-conditions-page';

export default (props: ITermsAndConditionsPageViewProps) => {
    return (
        <>
            <div data-content-type='row' data-appearance='contained' data-element='main'>
                <div
                    data-enable-parallax={0}
                    data-parallax-speed='0.5'
                    data-background-images='{}'
                    data-background-type='image'
                    data-video-loop='true'
                    data-video-play-only-visible='true'
                    data-video-lazy-load='true'
                    data-video-fallback-src
                    data-element='inner'
                    style={{
                        justifyContent: 'flex-start',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundPosition: 'left top',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundAttachment: 'scroll',
                        borderStyle: 'none',
                        borderWidth: '1px',
                        borderRadius: '0px',
                        margin: '0px 0px 10px',
                        padding: '10px'
                    }}
                >
                    <div
                        className='pagebuilder-column-group'
                        data-content-type='column-group'
                        data-grid-size={12}
                        data-element='main'
                        style={{ display: 'flex' }}
                    >
                        <div
                            className='pagebuilder-column'
                            data-content-type='column'
                            data-appearance='align-center'
                            data-background-images='{}'
                            data-element='main'
                            style={{
                                justifyContent: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                backgroundPosition: 'left top',
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundAttachment: 'scroll',
                                textAlign: 'center',
                                borderStyle: 'none',
                                borderWidth: '1px',
                                borderRadius: '0px',
                                width: '100%',
                                margin: '0px',
                                padding: '10px',
                                alignSelf: 'center'
                            }}
                        >
                            <div
                                data-content-type='html'
                                data-appearance='default'
                                data-element='main'
                                style={{
                                    borderStyle: 'none',
                                    borderWidth: '1px',
                                    borderRadius: '0px',
                                    margin: '0px',
                                    padding: '0px'
                                }}
                            >
                                <RichTextComponent text={props.config.content} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                data-content-type='row'
                data-appearance='contained'
                data-element='main'
                style={{
                    justifyContent: 'flex-start',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundPosition: 'left top',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'scroll',
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px',
                    margin: '0px 0px 10px',
                    padding: '10px'
                }}
            >
                <h2
                    className='Find-Your-Sample-Title'
                    data-content-type='heading'
                    data-appearance='default'
                    data-element='main'
                    style={{
                        textAlign: 'center',
                        borderStyle: 'none',
                        borderWidth: '1px',
                        borderRadius: '0px'
                    }}
                >
                    {props.config.footerTitle ? props.config.footerTitle : 'For more details'}
                </h2>
                <div
                    data-content-type='text'
                    data-appearance='default'
                    data-element='main'
                    style={{
                        borderStyle: 'none',
                        borderWidth: '1px',
                        borderRadius: '0px',
                        margin: '0px',
                        padding: '0px'
                    }}
                >
                    <RichTextComponent text={props.config.footerDetails} />
                </div>
            </div>
        </>
    );
};
